var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("版权所有：中国医院协会病案管理专业委员会 艾登科技")])}
var staticRenderFns = []

export { render, staticRenderFns }